import { network } from 'services/network';

import { Report } from 'api/endPoints/getReport';

export const createNewTemplateFromReport = (params: QueryParams) => {
    const url = `api/bo/reporting/createNewTemplateFromReport`;
    return network.post<QueryResponse>(url, params).then((response) => {
        return response.data;
    });
};

export interface QueryResponse {
    report: Report;
}

export interface ReportTemplateBase {
    reportId: number;
    name: string;
    description: string;
    tags: number[];
}

export interface QueryParams extends ReportTemplateBase {
    id: number | null;
}
